import React, { useState, useRef } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

export default function (props) {
  const {
    label,
    clearable,
    onBlur,
    onChange,
    InputProps,
    toolTipContent = "",
    type = "text", // Default to text, can be "number"
    value,
    ...rest
  } = props;


  const [inputValue, setInputValue] = useState(value || "");

  const toolTipContents =
    toolTipContent !== ""
      ? toolTipContent
      : rest.enableTooltip && inputValue && inputValue.length > 0
      ? inputValue
      : "";

  // Debounced change handler
  function handleChange(e) {
    const newValue = e.target.value;
    if (type === "number" && newValue !== "") {
      const parsedValue = parseFloat(newValue);
      if (isNaN(parsedValue)) return; // Ignore invalid number input
      setInputValue(parsedValue);
      if (onChange) onChange(parsedValue);
    } else {
      setInputValue(newValue);
      if (onChange) onChange(newValue);
    }
  }

  function handleBlur(e) {
    if (onBlur) onBlur(e.target.value);
  }

  function handleClear() {
    setInputValue("");
    if (onBlur) return onBlur("");
    if (onChange) return onChange("");
  }

  return (
    <Tooltip title={toolTipContents}>
      <TextField
        label={label}
        variant="outlined"
        autoComplete="off"
        type={type}
        value={inputValue}
        InputProps={{
          ...InputProps,
        endAdornment: clearable && inputValue !== "" && inputValue !== null && inputValue !== undefined &&(
            <InputAdornment position="end" style={{ marginRight: -8 }}>
              <IconButton
                size="small"
                onClick={handleClear}
                disabled={props.disabled}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onBlur={handleBlur}
        onChange={handleChange}
        {...rest}
      />
    </Tooltip>
  );
}
